/* §326（2026-10-15）メガメニューのパネルの中（CATEGORY・SCENE）とスマホのドロワーの CATEGORY の「左を選ぶと右が替わる」動き。
   開閉そのものは igniere-mega-menu.js（IgniereMegaMenu・IgniereHeaderDrawer）が受け持つ。形の正本＝作業/メガメニュー再設計_2026-10/試作/。
   - PC：左の行に乗せると右が替わる。ただし右の中身へ斜めに向かっている間は替えない（大手の通販の定石＝前の位置と今の位置から、右の中身の上下の角への傾きを比べる）
   - 最初に出す 1 つは HTML で決めてある（計測の決まり③）。PC は閉じた時に最初の 1 つへ戻す。スマホのドロワーは戻さない（§326-2・代表の確認表 6・8＝開き直すと同じ所から）
   - 左の一覧に初めて乗った時に、そのパネルのほかの中身の写真も読んでおく（替えた瞬間に写真が遅れないように）
   - 替わり方＝前の中身を上に重ねたまま 0.2 秒でフェードし、下の新しい中身が透けて出る（クロスフェード・§326-2 代表「もう少し上品に」）。
     前は前の中身を即座に隠して新しい中身を透明から出していた＝間に背景色が一瞬見えて「パッパッ」と点いた */
(() => {
  const track = [];
  document.addEventListener('pointermove', (e) => {
    track.push([e.clientX, e.clientY]);
    if (track.length > 6) track.shift();
  }, true);

  const still = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root, tabSel, paneSel, tabAttr, paneAttr, hover) {
    const tabs = [...root.querySelectorAll(tabSel)];
    const panes = [...root.querySelectorAll(paneSel)];
    if (!tabs.length) return null;
    let sel = 0;
    let pending = null;
    let leaving = null; // フェードしている途中の前の中身のアニメーション
    const paneOf = (i) => panes.find((p) => Number(p.dataset[paneAttr]) === i);
    const select = (i, animate = true) => {
      if (i === sel) return;
      leaving?.finish();
      const prev = paneOf(sel);
      sel = i;
      tabs.forEach((t) => t.setAttribute('aria-selected', String(Number(t.dataset[tabAttr]) === i)));
      panes.forEach((p) => { p.hidden = Number(p.dataset[paneAttr]) !== i; });
      if (!animate || !prev || still() || !prev.animate) return;
      prev.hidden = false;
      prev.classList.add('is-leaving');
      const a = prev.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 200, easing: 'ease-out' });
      leaving = a;
      const done = () => {
        prev.classList.remove('is-leaving');
        prev.hidden = Number(prev.dataset[paneAttr]) !== sel;
        if (leaving === a) leaving = null;
      };
      a.onfinish = done;
      a.oncancel = done;
    };
    const rightEl = panes[0]?.parentElement;
    const aiming = (e) => {
      if (!rightEl) return false;
      const last = track[track.length - 1];
      if (!last) return false;
      let [px, py] = last;
      const x = e.clientX;
      const y = e.clientY;
      if (px === x && py === y) {
        const p2 = track[track.length - 2];
        if (!p2) return false;
        [px, py] = p2;
      }
      const r = rightEl.getBoundingClientRect();
      if (x >= r.left || x <= px) return false;
      const s = (ax, ay, bx, by) => (by - ay) / (bx - ax);
      return s(x, y, r.left, r.top) < s(px, py, r.left, r.top) && s(x, y, r.left, r.bottom) > s(px, py, r.left, r.bottom);
    };
    let warmed = false;
    const warm = () => {
      if (warmed) return;
      warmed = true;
      root.querySelectorAll(`${paneSel} img[loading="lazy"]`).forEach((img) => {
        img.loading = 'eager';
        img.decode?.().catch(() => {});
      });
    };
    tabs.forEach((t) => {
      const i = Number(t.dataset[tabAttr]);
      if (hover) {
        t.addEventListener('pointerenter', (e) => {
          warm();
          clearTimeout(pending);
          pending = null;
          if (aiming(e)) {
            pending = setTimeout(() => { if (t.matches(':hover')) select(i); pending = null; }, 280);
          } else select(i);
        });
        t.addEventListener('pointermove', (e) => {
          if (!pending || aiming(e)) return;
          clearTimeout(pending);
          pending = null;
          select(i);
        });
      }
      t.addEventListener('click', () => { warm(); select(i); });
      t.addEventListener('focus', () => select(i));
      // §326-3 キーボード（点検 F1・WAI-ARIA のタブの型）：上下の矢印・Home・End で行を移って選ぶ。Tab は選んだ中身の最初のリンクへ進む
      t.addEventListener('keydown', (e) => {
        const at = tabs.indexOf(t);
        let to = -1;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') to = (at + 1) % tabs.length;
        else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') to = (at - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') to = 0;
        else if (e.key === 'End') to = tabs.length - 1;
        else if (e.key === 'Tab' && !e.shiftKey) {
          const first = paneOf(sel)?.querySelector('a[href], button, [tabindex="0"]');
          if (first) { e.preventDefault(); first.focus(); }
          return;
        }
        if (to < 0) return;
        e.preventDefault();
        e.stopPropagation();
        tabs[to].focus();
      });
    });
    // スクリーンリーダー向けの組み立て（点検 F1-2）＝li は role=presentation・行と中身の aria-controls／tabpanel・tabindex の初めの値は HTML に書いてある
    // （JS で付けると、Horizon がヘッダーを描き直す時に消える＝2026-10-15 実測）。ここでは選び直した時の tabindex だけ合わせる
    const rove = () => tabs.forEach((t) => { t.tabIndex = Number(t.dataset[tabAttr]) === sel ? 0 : -1; });
    rove();
    new MutationObserver(rove).observe(root, { attributes: true, attributeFilter: ['aria-selected'], subtree: true });
    return { reset: () => select(0, false) };
  }

  function init() {
    // PC のメガメニュー
    const mega = document.querySelector('igniere-mega-menu');
    const megaSets = [...document.querySelectorAll('[data-ig-mx]')]
      .map((root) => setup(root, '[data-ig-mx-tab]', '[data-ig-mx-pane]', 'igMxTab', 'igMxPane', true))
      // §334 MAGAZINE のタブ（LATEST・INFORMATION・JOURNAL）＝押して替える（乗せただけでは替えない・代表 FIX 2026-10-16）。閉じたら LATEST へ戻すのはほかと同じ
      .concat([...document.querySelectorAll('[data-ig-mgx]')]
        .map((root) => setup(root, '[data-ig-mgx-tab]', '[data-ig-mgx-pane]', 'igMgxTab', 'igMgxPane', false)))
      .filter(Boolean);
    if (mega && megaSets.length) {
      // 閉じたら最初の 1 つへ戻す。ただしパネルが薄くなり終わってから（§326-3・点検 F2＝消えていく途中のパネルに Wear が出ていた。パネルの消え方は igniere-mega-menu.css の 0.32 秒）
      let resetTimer = null;
      new MutationObserver(() => {
        clearTimeout(resetTimer);
        if (mega.hasAttribute('data-open')) return;
        resetTimer = setTimeout(() => {
          if (!mega.hasAttribute('data-open')) megaSets.forEach((m) => m.reset());
        }, 360);
      }).observe(mega, { attributes: true, attributeFilter: ['data-open'] });
    }
    // §327 TOP の「探す」のタブ（カテゴリー・シーン・ブランド＝押して替える・sections/igniere-category-feature.liquid）
    document.querySelectorAll('[data-ig-tabs]')
      .forEach((root) => setup(root, '[data-ig-tab]', '[data-ig-tab-pane]', 'igTab', 'igTabPane', false));
    // スマホのドロワーの CATEGORY・SCENE（押して替える・閉じても選択を残す）
    document.querySelectorAll('[data-ig-dx]')
      .forEach((root) => setup(root, '[data-ig-dx-tab]', '[data-ig-dx-pane]', 'igDxTab', 'igDxPane', false));
  }

  // §327-6 テーマエディタでセクションを描き直した時に、TOP のタブを結び直す（読み込み時の 1 回だけだと押せなくなる・点検 F9）
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-ig-tabs]')
      .forEach((root) => setup(root, '[data-ig-tab]', '[data-ig-tab-pane]', 'igTab', 'igTabPane', false));
  });

  // §327-13 ITEM TYPE の欄（スクロールバーを出さない）：下にまだ種類がある時だけ下の端をぼかす（data-more・CSS の mask）。
  // スクロールした時は捕まえる側（document の capture）で拾う＝Horizon がヘッダーを描き直して要素が替わっても効く。中身を替えた・開いた時は大きさの変化で拾う
  const more = (tl) => tl.toggleAttribute('data-more', tl.scrollTop + tl.clientHeight < tl.scrollHeight - 1);
  document.addEventListener('scroll', (e) => { if (e.target instanceof Element && e.target.matches('.ig-mx__tl')) more(e.target); }, true);
  const watchTl = () => {
    if (!window.ResizeObserver) return;
    const ro = new ResizeObserver((entries) => entries.forEach((en) => more(en.target)));
    document.querySelectorAll('.ig-mx__tl').forEach((tl) => ro.observe(tl));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchTl, { once: true });
  else watchTl();

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
